// Helper to get the correct base path for assets
// Works for both development, GitHub Pages, and custom domains over HTTPS
export const getAssetPath = (path) => {
  // Always build a relative URL so we don't hard-code http/https or repo names
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  // Always use relative paths - this works for localhost, custom domains, and GitHub Pages
  // Relative paths automatically work with the current domain and protocol (HTTP/HTTPS)
  return `/${cleanPath}`;
};

